module.exports = __webpack_public_path__ + "img/text-square.7f501c7c.svg";